<template>
  <div class="bg-toast-host" aria-live="polite" aria-relevant="additions">
    <transition-group name="bg-toast-stack" tag="div" class="bg-toast-host__list">
      <article
        v-for="item in items"
        :key="item.id"
        class="bg-toast-card"
      >
        <p class="bg-toast-card__message">{{ item.message }}</p>
        <div class="bg-toast-card__track" aria-hidden="true">
          <div
            class="bg-toast-card__bar"
            :style="{ animationDuration: item.duration + 'ms' }"
            @animationend="remove(item.id)"
          />
        </div>
      </article>
    </transition-group>
  </div>
</template>

<script>
import { ToastBus } from '@/utils/toast'

let toastSeq = 0

export default {
  name: 'BlackGoldToastHost',
  data () {
    return {
      items: []
    }
  },
  mounted () {
    ToastBus.$on('toast:show', this.add)
  },
  beforeDestroy () {
    ToastBus.$off('toast:show', this.add)
  },
  methods: {
    add ({ message, duration }) {
      const id = ++toastSeq
      this.items.push({ id, message, duration })
      window.setTimeout(() => this.remove(id), duration + 100)
    },
    remove (id) {
      this.items = this.items.filter(item => item.id !== id)
    }
  }
}
</script>
